import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Box, AvatarWithLabel, Chip, Typography, Loader, UserAvatar, TeamAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { localizedDistanceToNow } from 'shared/domains/common-utils';
import { useProject } from './useProject';
import { ProjectContractTermChip } from '../../ProjectContractTermChip';
import { ProjectStatusChip } from '../../ProjectStatusChip';
import { Body, Description, Divider, Footer, Header, PopoverContentContainer } from './styled';
export function PopoverContent(props) {
    const { projectId } = props;
    const { project, members, projectOwners, loading, error } = useProject(projectId);
    if (loading || !project) {
        return (<PopoverContentContainer>
        <Header>
          <AvatarWithLabel size="md" shape="square" appearance="light" title={t({
                message: 'Loading',
                comment: 'Project popover: Loading project details label',
            })} subtitle={t({
                message: 'Loading project details...',
                comment: 'Project popover: Loading project details label',
            })}>
            <Loader />
          </AvatarWithLabel>
        </Header>
      </PopoverContentContainer>);
    }
    if (error) {
        return null;
    }
    const { customerId, description, updatedAt, status, contractTerm, nodesCount, name } = project || {};
    const formattedUpdatedAt = localizedDistanceToNow(updatedAt);
    const renderMembers = projectOwners.length > 0 || members.users.length > 0 || members.teams.length > 0;
    return (<PopoverContentContainer>
      <Header>
        <AvatarWithLabel size="md" shape="square" appearance="light" title={name} subtitle={customerId !== null && customerId !== void 0 ? customerId : undefined}>
          <Falcon icon="rectangle-history"/>
        </AvatarWithLabel>
      </Header>
      {description && (<Box pb="xl" pr="xl" pl="xl">
          <Description>
            <Typography $fontSize="tiny" $appearance="200" $lineHeight="neutralized">
              {description}
            </Typography>
          </Description>
        </Box>)}
      <Divider />
      <Body>
        <ProjectStatusChip status={status} size="medium" showLabel/>
        <ProjectContractTermChip contractTerm={contractTerm} size="medium" showLabel/>
        <Chip icon={<Falcon icon="file"/>} label={t({
            message: 'Documents',
            comment: 'Project popover: Documents chip label',
        })} appearance={nodesCount > 0 ? 'info' : 'secondary'} secondary={nodesCount.toString()}/>
      </Body>
      {renderMembers && (<Fragment>
          <Divider />
          <Box flexDirection="column" p="xl" gap="md">
            {projectOwners.map((user) => (<UserAvatar size="sm" key={user.id} title={user.name} subtitle={t({
                    message: 'Project owner',
                    comment: 'Project popover: Project owner label',
                })}/>))}
            {members.users.map((user) => (<UserAvatar size="sm" key={user.id} title={user.name}/>))}
            {members.teams.map((team) => (<TeamAvatar size="sm" key={team.id} title={team.name}/>))}
          </Box>
        </Fragment>)}
      <Divider />
      <Footer>
        <Box alignItems="center" gap="md">
          <Falcon icon="pencil" $color="swatches.gray.500" $size={14}/>
          <Typography $fontSize="tiny" $appearance="100">
            {formattedUpdatedAt}
          </Typography>
        </Box>
      </Footer>
    </PopoverContentContainer>);
}
